export default __webpack_public_path__ + "static/media/landscape.45c8bff3.png";